module.exports = __webpack_public_path__ + "img/criteo-app.b8ac483d.svg";